export default __webpack_public_path__ + "static/left-b81381407e98810f6f5057f7a4c1109b.png";